module.exports = __webpack_public_path__ + "img/Path 529.db78bc6d.svg";